<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      paddingBottom: '10px'
    }"
  >
    <header-o :model="headerData"></header-o>
    <div
      class=""
      style="margin-right: 15px; margin-left: 15px; margin-top: -170px "
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '10px'
        }"
        class="past-history-section common-section height-90"
      >
        <!-- Winner Section Start -->
        <div class="past-history-title text-center">
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderRadius: '10px'
            }"
            class="offer-card bg-light pos-rel box-shadow "
            style="padding: 1px;"
          >
            <div class="winner-section text-center ">
              <div class="title" style="margin-top: 10px;">
                <span
                  style=" font-size: 20px;
                          font-family: 'Montserrat-bold',sans-serif;
                          font-weight: lighter;"
                  >Winners
                </span>
              </div>

              <div
                class="row align-items-center"
                style="    display: flex;
                            justify-content: center;
                            margin-right: 0px;
                            margin-left: -30px;"
              >
                <div
                  class="col-2"
                  :style="{ visibility: !leaderboard[1] ? 'hidden' : '' }"
                >
                  <div
                    class="winner-block"
                    style="display: flex;justify-content: center;flex-direction: column;width: 86px;"
                  >
                    <img
                      src="@/assets/rank-2.svg"
                      alt="rank-2"
                      class="img-fluid"
                    />
                    <span style="font-size: 16px; font-weight: 600;">{{
                      leaderboard[1] ? leaderboard[1].user_name : "--"
                    }}</span>

                    <span
                      style="font-size: 15px;"
                      :style="{ color: isDarkTheme ? topBgColor : bgTheme }"
                      >{{ leaderboard[1] ? leaderboard[1].prize + " " : 0
                      }}{{ Raffle_currencyLable }}
                    </span>
                    <!-- <span>{{
                      leaderboard[1] ? leaderboard[1].user_name : "--"
                    }}</span> -->
                  </div>
                </div>
                <div
                  class="col-2"
                  :style="{ visibility: !leaderboard[0] ? 'hidden' : '' }"
                >
                  <div
                    class="winner-block first-rank"
                    style="display: flex;justify-content: center;flex-direction: column;width: 86px;"
                  >
                    <img
                      src="@/assets/rank-1.svg"
                      alt="rank-1"
                      class="img-fluid"
                    />
                    <span style="font-size: 16px; font-weight: 600;">{{
                      leaderboard[0] ? leaderboard[0].user_name : "--"
                    }}</span>
                    <span
                      style="font-size: 15px;"
                      :style="{ color: isDarkTheme ? topBgColor : bgTheme }"
                      >{{ leaderboard[0] ? leaderboard[0].prize + " " : 0
                      }}{{ Raffle_currencyLable }}</span
                    >
                  </div>
                </div>
                <div
                  class="col-2"
                  :style="{ visibility: !leaderboard[2] ? 'hidden' : '' }"
                >
                  <div
                    class="winner-block"
                    style="display: flex;justify-content: center;flex-direction: column;width: 86px;"
                  >
                    <img
                      src="@/assets/rank-3.svg"
                      alt="rank-3"
                      class="img-fluid"
                    />
                    <span style="font-size: 16px; font-weight: 600;">{{
                      leaderboard[2] ? leaderboard[2].user_name : "--"
                    }}</span>
                    <span
                      style="font-size: 15px;"
                      :style="{ color: isDarkTheme ? topBgColor : bgTheme }"
                      >{{ leaderboard[2] ? leaderboard[2].prize + " " : 0
                      }}{{ Raffle_currencyLable }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="history-table"
            v-if="leaderboard && leaderboard.length != 0"
          >
            <div
              class="table-responsive past-history-title"
              style="box-sizing: border-box;"
            >
              <table class="table table-borderless">
                <thead>
                  <tr>
                    <th>
                      <span
                        style="font-family: 'Montserrat-bold';
    font-size: 14px; font-weight: 200; color: black;"
                        >Rank</span
                      >
                    </th>
                    <th>
                      <span
                        style="font-family: 'Montserrat-bold';font-size: 14px;font-weight: 200; color: black;"
                        >User</span
                      >
                    </th>
                    <th>
                      <span
                        style="font-family: 'Montserrat-bold';
    font-size: 14px;"
                        >{{ Raffle_currencyLable }}</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if="leaderboard && leaderboard.length > 2"
                    :style="{
                      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
                      paddingLeft: '12px'
                    }"
                    class="your-rank"
                  >
                    <td style="padding: 10px 15px;">
                      {{ userData.rank }}
                    </td>
                    <td style="padding: 10px 15px;" class="name">
                      {{ userData.user_name }}
                    </td>
                    <td style="padding: 10px 15px;">{{ userData.prize }}</td>
                  </tr>
                  <tr v-for="item in leaderboard" style="margin-left: 12px;">
                    <td style="padding: 10px 15px;">{{ item.rank }}</td>
                    <td style="padding: 10px 15px;" class="name">
                      {{ item.user_name }}
                    </td>
                    <td style="padding: 10px 15px;">{{ item.prize }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Winner Section End -->
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import moment from "moment";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        showmore: false
      },
      is_shimmer: true,
      leaderboard: [],
      Raffle_currencyLable: "",
      userData: {}
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();
  },
  beforeDestroy() {
    clearInterval(this.intervalid);
  },
  methods: {
    getRaffleConcertDetailList(id) {
      axios.all([this.getRaffleConcertDetailById(id)]).then(
        axios.spread(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            this.leaderboard = resp.data.leaderboard;
            this.userData = resp.data.user_data;
          }
        })
      );
    },
    showMore() {
      this.leadeboardData = this.fullListData;
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "Raffle";
    this.Raffle_currencyLable = this.$store.state.Raffle_currencyLable;
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
    if (!this.isEmpty(this.$route.params)) {
      this.getRaffleConcertDetailList(this.$route.params.id);
      store_state.headTitle = this.$route.query.title;
    }
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.vl {
  border-left: 1px solid #b9b9b9;
  height: 106px;
  /* position: absolute; */
  left: 50%;
  margin-left: 7px;
  top: 0;
}
.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 14px;
  line-height: 14px;
  /* color: #373535; */
  font-weight: 200;
}
.table-responsive {
  display: block;
  /* width: 100%; */
  overflow-x: auto;
  /* color: black; */
}
th,
tr {
  display: flex;
  justify-content: space-between;
}

.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 10px;
  line-height: 19px;
  /* color: #373535; */
  font-weight: 200;
}
.myfont {
  margin: 20px;
  font-size: 20px;
  font-weight: 700;
  font-family: "Montserrat-bold", sans-serif;
  overflow-wrap: break-word;
}
</style>
